import { useState, useEffect } from 'react';
import './style.common.scss';
import LineChart from 'app/shared/LineChart';
// import { Table } from '@intellicar/phoenix-design-system';
import Table from 'app/shared/Table';
import { orderBy } from 'lodash';
import { JSONTOCSV } from 'utils/HelperFunctions';
import { getUserInfo } from 'utils/auth';
import moment from 'moment';
import { ReactComponent as ExpandIcon } from 'assets/icons/expand.svg';
import { ReactComponent as DownloadIcon } from 'assets/icons/download.svg';
// import SearchBox from 'app/shared/SearchBox';
function ChargeHistory(props) {
	const [activeTab, setActiveTab] = useState(0);
	const [openModal, setOpenModal] = useState(false);
	// const [updatedAt, setUpdatedAt] = useState();
	//eslint-disable-next-line
	const [searchQuery, setSearchQuery] = useState('');

	useEffect(() => {
		setActiveTab(0);
	}, [props.isLive]);

	const getCSVName = () => {
		let auth = getUserInfo();
		let date = moment().format('DD-MM-YYYY_h:mmA');
		return auth.username + '_Charging_Event_Log_' + date;
	};

	const getSortedData = () => {
		let metaData = JSON.parse(sessionStorage.getItem('evdashboardchargetracker'));
		let FiletrData = [];
		// var now = new Date();
		// let back4Hrs = now.setHours(now.getHours() - 4);
		if (metaData && metaData.lastupdate) {
			for (let i in props.data) {
				if (props.data[i].time <= metaData?.lastupdate) {
					FiletrData.push(props.data[i]);
				}
			}
		} else {
			FiletrData = props.data;
		}
		let sortedData = orderBy(FiletrData, ['time'], ['asc']);
		sortedData.sort(function (a, b) {
			return (a['time'] === null) - (b['time'] === null);
		});
		return sortedData;
	};

	useEffect(() => {
		let sortedData = getSortedData();
		if (sortedData.length > 0) {
			// setUpdatedAt(
			// 	sortedData
			// 		? moment(sortedData[sortedData.length - 1].time).format('DD MMM YYYY, h:mm A')
			// 		: 'Not available'
			// );
		}
		//eslint-disable-next-line
	}, [props.data]);

	const processTableHeader = () => {
		let processed = [];
		for (let idx in props.heads) {
			let obj = {
				title: props.heads[idx].heading,
				key: props.heads[idx].key,
				sortable: true,
				dataIndex: props.heads[idx].key,
				align: 'right',
			};
			if (props.heads[idx].key === 'time') {
				obj.align = 'left';
				obj.render = (text) => {
					return (
						<div style={{ display: 'flex', flexDirection: 'column' }}>
							<span>{moment(parseInt(text)).format('D MMM YYYY h:mm A')}</span>
						</div>
					);
				};
			}
			processed.push(obj);
		}
		return processed;
	};

	const processTableData = () => {
		let processed = { ...props.data };
		for (let idx in processed) {
			processed[idx].time = moment(processed[idx].time).format('D MMM YYYY h:mm A');
		}
		return processed;
	};

	const processChartData = () => {
		let data = getSortedData();
		let processedData = [];
		for (let idx in data) {
			processedData.push({
				x: data[idx].hours,
				y: data[idx].count,
				date: data[idx].hours,
			});
		}
		return processedData;
	};

	// const searchTable = (key) => {
	// 	// if (key.length < 3) return;
	// 	setSearchQuery(key);
	// };

	const renderWidgetControl = () => {
		return (
			<div
				className="WidgetControl"
				style={{ justifyContent: activeTab === 1 ? 'space-between' : 'flex-end' }}
			>
				{activeTab === 1 ? (
					<div className="SearchControl">
						{/* <SearchBox placeholder={'Search'} onSearch={searchTable} rounded /> */}
					</div>
				) : null}
				<div className="WidgetTab">
					<ul>
						<li onClick={() => setActiveTab(0)} className={activeTab === 0 ? 'active' : ''}>
							Chart
						</li>
						<li onClick={() => setActiveTab(1)} className={activeTab === 1 ? 'active' : ''}>
							Table
						</li>
					</ul>
				</div>
			</div>
		);
	};
	const renderView = () => {
		return activeTab === 0 ? (
			<div className="GraphView">
				<LineChart
					data={processChartData() || []}
					color={'#5CE3B5'}
					gradient={true}
					enableCrosshair={true}
					tooltip={renderGraphTooltip()}
					tooltipLabels={{ label: 'Charging Events', icon: 'fas fa-charging-station' }}
				/>
			</div>
		) : (
			<div className="tableView">
				<Table
					columns={processTableHeader()}
					dataSource={getSortedData()}
					// searchQuery={searchQuery}
					searchKey={'vehno'}
					striped
					slim
					modal={openModal}
				/>
			</div>
		);
	};
	const renderGraphTooltip = () => {
		return <div className="TooltipNivo">Hi</div>;
	};
	return (
		<div className="WidgetContainer">
			<div className="WidgetHeader">
				<div className="Title">Charging Event Log</div>
				{/* {updatedAt && <div style={{ fontSize: 10 }}>* Last updated at {updatedAt}</div>} */}
				<div className="RightControl">
					<DownloadIcon
						onClick={() => JSONTOCSV(processTableData(), processTableHeader(), getCSVName())}
						style={{ marginRight: 14, cursor: 'pointer' }}
					/>
					<ExpandIcon style={{ cursor: 'pointer' }} onClick={() => setOpenModal(true)} />
				</div>
			</div>
			<div className="WidgetContent">
				{renderWidgetControl()}
				<div className="ContentContainer">{renderView()}</div>
			</div>

			<div className="Modal" style={{ display: openModal ? 'block' : 'none' }}>
				<div className="ModalContent">
					<div className="ModalHeader">
						<span onClick={() => setOpenModal(false)} className="close">
							&times;
						</span>
					</div>
					<span
						className="mh-download"
						style={{ position: 'relative', top: '0.5rem', float: 'right' }}
					>
						<DownloadIcon
							onClick={() => JSONTOCSV(processTableData(), processTableHeader(), getCSVName())}
							style={{ marginRight: 14, cursor: 'pointer' }}
						/>
					</span>
					<div
						className="Title"
						style={{ fontWeight: 500, position: 'relative', top: '5px', width: '500px' }}
					>
						Charging Event Log
					</div>
					<div className="ModalContainer">
						{renderWidgetControl()}

						<div className="WidgetView" style={{ height: '80%' }}>
							{renderView()}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default ChargeHistory;
